var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseNotification',{attrs:{"to":_vm.link,"content":_vm.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }